import { TranslateFunction } from "../../../../hooks/useTranslate";

export const mainTableColumnTitles = (t: TranslateFunction): string[] => [
    t('table.columnsTitles.substance'),
    t('table.columnsTitles.substanceDescription'),
    t('table.columnsTitles.chemicalAndComercialName'),
    t('table.columnsTitles.cuit'),
    t('table.columnsTitles.type'),
    t('table.columnsTitles.actions'),
];


export const NEW_PROVIDER_OR_BUYER_TYPE_OPTIONS = [
    { id: 1, descripcion: 'Proveedor' },
    { id: 2, descripcion: 'Comprador' }
];